import { Dialog, DialogTitle, DialogContent, DialogActions, Button, DialogProps, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDialogState } from '../../stores/states/useDialogState';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { StyledFillButton, StyledOutlineButton, StyledTextButton } from '../../styled/filled_button';
import { SwalLeaveConfirm } from './swal_alert';
import ModalFooter from 'rsuite/esm/Modal/ModalFooter';

interface ZustandDialogContainerProps extends DialogProps {
    children?: ReactNode;
    title?: string;
    padding?: string;
    confirmBeforeClose?: boolean;
    onDialogDidClosed?: () => void;
    hasCloseIcon?: boolean;
    footer?: ReactNode;
}

export const ZustandDialogContainer = ({
    children,
    onClose,
    confirmBeforeClose,
    onDialogDidClosed,
    title = '',
    padding = '0px',
    hasCloseIcon = false,
    footer = <></>,
    ...dialogProps
}: ZustandDialogContainerProps) => {
    const closeDialog = useDialogState((state) => state.closeDialog);

    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (confirmBeforeClose) {
            SwalLeaveConfirm(
                () => {
                    onDialogDidClosed?.();
                },
                () => {
                    onDialogDidClosed?.();
                    closeDialog();
                }
            );
        } else {
            onDialogDidClosed?.();
            closeDialog();
        }
    };

    return (
        <Dialog
            onClose={handleClose}
            maxWidth={false} // Disable predefined maxWidth
            fullWidth={false} // Disable full width
            sx={{
                '& .MuiDialog-paper': {
                    width: 'auto', // Ensure the dialog wraps its content
                    maxWidth: '90%', // Optional: Limit max width to 90% of the viewport
                },
            }}
            {...dialogProps}
        >
            {title && (
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        transition: 'box-shadow 0.3s ease',
                        zIndex: 1,
                    }}>
                    {title}
                    {hasCloseIcon && (
                        <IconButton
                            aria-label="close"
                            onClick={() => {
                                onDialogDidClosed?.();
                                closeDialog();
                            }}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.secondary.light,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    )}
                </DialogTitle>
            )}
            <DialogContent sx={{ padding }}>{children}</DialogContent>
            <ModalFooter>{footer}</ModalFooter>
        </Dialog>
    );
};